import { useMemo } from 'react';

import { usePollsGateway } from './PollsGatewayProvider';
import { getMyPollResponsesV2QueryOptions } from '../api/pollResults';
import { getAnsweredPolls } from '../model/pollHistory';

import { useUserScopedQuery } from '@/hooks/useUserScopedQuery';

/**
 * The polls the signed-in user has answered, one entry per poll. Shared by the
 * Account entry points, which show only once there is something to list, and
 * by the poll history screens, so all of them agree on what counts.
 */
export function usePollHistory() {
  const { data, isLoading, isError, refetch } = useUserScopedQuery(
    getMyPollResponsesV2QueryOptions,
    [usePollsGateway()]
  );

  const polls = useMemo(() => getAnsweredPolls(data ?? []), [data]);

  return { polls, isLoading, isError, refetch };
}
